module.exports = __webpack_public_path__ + "img/banner2.29c8108f.png";